/**
 * 数据连接的统一管理
 */
//url池
//
import dtocean from "@/utils/map/oceanLayers";
import { baseUrl } from '@/service/apis'
const token = "yy2018devtoken";
let aisFirstBaseUrl =
    "http://47.100.49.112:19080/dataapi/common/cmd?token=" +
    // 'http://192.168.1.24:19080/common/cmd?token=' +
    token +
    "&method=";
let aisBaseUrl = "http://ocean.readearth.com:8011/fishser/app/shipinfo/search/extent";

export let fishSysBaseUrl = "http://ocean.readearth.com:8011/fishser/";

// let fishSysBaseUrl = "http://192.168.2.105:8089/fishser/";

let squidBaseUrl = "http://47.100.49.112:18083/ZsTuna/";

// 本系统，金枪鱼的地址
// let tunaUrl = "http://192.168.2.4:8092/ZsTuna/"
const tunaIps = {
    production: "http://47.100.49.112:19080/ZsTunaServer/",
    dev: "http://192.168.1.49:8092/ZsTuna/"
}
let rootPath = tunaIps.production
let tunaUrl = rootPath
let ZsTunaApi = "http://47.100.49.112:19080/ZsTunaServer/ZsTunaApi/"
let historyNumUrl = tunaUrl + "ZsTunaApi/GetThunHistory"
let tunaUrlConf = {
    // 查询中国，日本，韩国的渔船
    getCountryShip: tunaUrl + 'ZsTunaApi/GetCountryShip',
    // 获取渔船信息
    getShipInfo: fishSysBaseUrl + 'app/shipinfo/search/exact',
    // getShipInfo: tunaUrl + 'ZsTunaApi/GetShipInfo',
    //中水渔船
    getZsShips: tunaUrl + 'ZsTunaApi/GetZsShip',
    //中水模型数据url
    getModelUrl: "http://47.100.49.112:18080/tuna/",
    //作业规律
    getWorkRule: "http://47.100.49.112:18080/tuna/workrule",
    //渔船类型
    getShipType: tunaUrl + "ZsTunaApi/GetCode?typeid=03",
    getShipType: tunaUrl + "ZsTunaApi/GetCode?typeid=03",
    //发送邮件
    sendEmail: tunaUrl + "mail/sendMail",
    uploadFile: tunaUrl + "mail/uploadFile",
    //获取国际数据历史产量年份
    nationalYears: tunaUrl + "ZsTunaApi/GetYear",
    //获取中水数据历史产量年份
    zsYears: tunaUrl + "ZsTunaApi/GetZSYear",
    login: ZsTunaApi + "login",
    deleteAnnotation: fishSysBaseUrl + "annotation/deleteAnnotation",
    getFisherArea: fishSysBaseUrl + "/code/getFisherArea",
    queryAnnotation: fishSysBaseUrl + "annotation/queryAnnotations",
    // sendEmail: `http://192.168.1.12:8092/ZsTuna/mail/sendMail`
}


//重用渔业接口
let fisherUrlConf = {
    //历史轨迹
    aisHistrailUrl: fishSysBaseUrl + 'app/shipinfo/trace',
    //关注渔船url
    focusShipUrl: fishSysBaseUrl + "app/user/shipinfo",
    //港口
    shiportUrl: fishSysBaseUrl + "app/shipinfo/portList?sv=",
    loginUrl: fishSysBaseUrl + "app/login/psd",
    //vip到期检验
    vipCheckUrl: fishSysBaseUrl + "app/login/viptime?v=",
    //获取权限url
    getRightUrl: "http://47.100.49.112/dtadmin/api/user/rights.html?uid=",
    ///发送验证码url
    sendCodeUrl: fishSysBaseUrl + "app/sms/send/pc?pnum=",
    ///验证码登录url
    codeLoginUrl: fishSysBaseUrl + "app/login/sms?",
    getUserInfoUrl: fishSysBaseUrl + "app/user/detail?id=",
    //当前台风
    currTyphoonUrl: fishSysBaseUrl + "onboard/map/typhoon/curlist",
    //根据年份获取台风
    // typhoonByYearUrl: fishSysBaseUrl + 'onboard/map/typhoon/listbyyear?year=',
    //   typhoonByYearUrl: 'https://www.xiumin.vip/globaltc/world/tcs?',
    typhoonByYearUrl: baseUrl + "/onboard/map/Gettyphoonlist?",

    //根据编号获取台风路径（西太）
    wpTyphoonTrialUrl: "https://www.readearth.com/typhoon/",

    // //根据编号获取台风路径
    // typhoonTrialUrl: "https://www.xiumin.vip/globaltc/world/subjectivetracks?",
    // //获取台风区域列表
    typhoonAreaUrl: "https://www.xiumin.vip/globaltc/world/allseas",

    //根据编号获取台风路径
    typhoonTrialUrl: baseUrl + "/onboard/map/Gettyphoonpoints?",
    //获取台风区域列表
    //   typhoonAreaUrl: fishSysBaseUrl + 'onboard/map/Gettyphoonlist',

    //台风预报路径url
    typhoonForePathUrl: "http://139.196.89.166/globaltc/world/forecasttracks",

    //改变渔船的关注状态
    changeFocusShipUrl: fishSysBaseUrl + "app/user/gz?",
    //获取要素的图表的url
    oceanChartUrl: fishSysBaseUrl + "onboard/map/point_extract_forecast?",
    //实时天气url
    realtimeWeatherUrl: fishSysBaseUrl + "app/api/weather?",
    //预报天气url
    forecastWeatherUrl: fishSysBaseUrl + "app/api/weather/forecast?",
    getShipByMMSIOrNameUrl: baseUrl + "/onboard/map/search/vague?v=",
    getAisByMMSIUrl: fishSysBaseUrl + "app/shipinfo/search/exact?mmsi=",
    // getAisByMMSIUrl: fishSysBaseUrl + 'app/shipinfo/search/exact?mmsi=',
    getNcJsonUrl: "http://202.96.202.170/api/eds/geojson?",
    //单点查询
    getPointValueUrl: fishSysBaseUrl + "/onboard/map/point_extract?",
    temperatureFract: baseUrl + "/temperatureChart",
    getNearestOceanTime: "http://diting.kmdns.net:9900/WebService_Staging/api/v1/AnalysisInfo/EDSDataQuery/EDSTimeQuery/",
    // tempChla: "http://readearth2014.vicp.cc:9126/oceanslabJava/chart/oceanFish/tempAndCurrent",
    tempChla: baseUrl + "/tempAndCurrent",

    //oceanlab的单点查询
    getPointValueUrl2: function(
        layerName,
        stime,
        bbox,
        screenW,
        screenH,
        screenX,
        screenY
    ) {
        return dtocean.getOceansLabPointUrl(
            layerName,
            stime,
            bbox,
            screenW,
            screenH,
            screenX,
            screenY
        );
    },
    //oceanlab的时间序列
    oceanChartUrl2: function(
        layerName,
        stime,
        days,
        bbox,
        screenW,
        screenH,
        screenX,
        screenY,
        zlayer
    ) {
        return dtocean.getOceansLabTimeForecastUrl(
            layerName,
            stime,
            days,
            bbox,
            screenW,
            screenH,
            screenX,
            screenY,
            zlayer
        );
    },

    //上传渔场预测url
    uploadFisherUrl: fishSysBaseUrl + "app/fisharea/form?",
    //上传渔场预测详情
    uploadFisherDetailUrl: fishSysBaseUrl + "app/fisharea/sub/form?",
    //获取渔场预测列表
    getFisherUrl: fishSysBaseUrl + "app/fisharea/pagelist?",

    //删除渔场预测列表
    deleteFisherUrl: fishSysBaseUrl + "app/fisharea/move?id=",
    //获取渔场预测详情
    getFisherDetailUrl: fishSysBaseUrl + "app/fisharea/sub/list?",
    //获取渔捞日志列表
    getFisherLogUrl: fishSysBaseUrl + "online/analysis/fish/search?",
    //获取渔场日志列表用于地图
    getFisherLogMapUrl: fishSysBaseUrl + "online/analysis/grid/fishCatch?",

    //更新密码的url
    updatePassUrl: fishSysBaseUrl + "app/user/updatePwd",

    //更新在线状态的url
    updateOnlineStatusUrl: fishSysBaseUrl + "sessionmanager/updateSession",
    //登出url
    loginOutUrl: fishSysBaseUrl + "sessionmanager/logout",

    getQrCodeUrl: fishSysBaseUrl + "upload",
    //zoujuan
    sendEmailUrl: fishSysBaseUrl + "admin/sendMail",
    getEmailListUrl: fishSysBaseUrl + "admin/getMailList",
    getEmailHistoryUrl: fishSysBaseUrl + "admin/getMailHistory",
};

/**
 * 鱿鱼基础URL
 */
let squidBaseUrlConf = {
    //景气指数数据url
    ProsperityIndexUrl: squidBaseUrl + "Prosperity/Index",
    //渔场信息url
    FisherInfoUrl: squidBaseUrl + "fishery/findAll",

    /*
     *  LeftContent
     */
    //渔场信息页面
    FishInfoUrl: squidBaseUrl + "fishery/CoordinateSearch/",
    //资源丰度
    ResourceAbundanceYearUrl: squidBaseUrl + "Resources/findYear/",
    ResourceAbundanceMonthUrl: squidBaseUrl + "Resources/findMonth/",
    // 鱿鱼价格
    inlandPriceUrl: squidBaseUrl + "test/SquidPrice/",
    foreignPriceUrl: "/",
    //价格指数
    priceIndex: squidBaseUrl + "test/PriceIndex/",
    // 实验生物学(渔获质量)
    ExperimentUrl: squidBaseUrl + "test/demo1/",
    // ExperimentUrl:'http://192.168.1.193:8080/'+'test/demo1/',
    //胴长，净重
    CarcassLength: squidBaseUrl + "test/CarcassLength/",
    NetWeight: squidBaseUrl + "test/netWeight/",
    //渔船轨迹
    BoatTrail: squidBaseUrl + "fishery/ProductionStatistics",
    //体重统计图
    Weight: squidBaseUrl + "test/Weight/",
    //胴长统计图
    CarcassLengthSample: squidBaseUrl + "test/CarcassLengthZh/",
    //预报 周数据
    ReportWeek: squidBaseUrl + "test/FindWeeklyyield/",
    //预报 总计数据
    ReportTotal: squidBaseUrl + "test/FindCumulativeProduction/",
    //预报 公司列表
    Company: squidBaseUrl + "test/FindWeeklyName/",
    //实验生物学 捕捞时间
    CatchTime: squidBaseUrl + "test/Findqualitydate/",
    //单艘船 捕捞时间
    CatchTimeSingle: squidBaseUrl + "test/FindSingleboatTime/",
    //捕捞时间对应经纬度
    CatchTimeLonLat: squidBaseUrl + "test/FindSingleboatlonandlat/",
    //pdf文件接口
    PdfSrc1: squidBaseUrl + "test/Findfilename1",
    PdfSrc2: squidBaseUrl + "test/Findfilename2",

    //指数信息录入
    //获取已上传列表
    getFileListUrl: squidBaseUrl + "test/findfileviewname/",
    //删除xlsx文件
    deleteFileByIdUrl: squidBaseUrl + "test/deletefileviewname/",
    //删除pdf
    deletePdfFileUrl: squidBaseUrl + "test/deletepdfname/",
    //登录验证
    loginCheckUrl: "http://119.3.104.235/admin/login/AjaxloginCheck.html",
    // 获取权限
    getRightsUrl: "http://119.3.104.235/admin/api/user/rights.html",

    //日报公司的总产量
    TotalDailyOutPutUrl: squidBaseUrl + "/test/TotalDailyOutPut/",
    //日报公司的周产量
    TotalDailyOutPutWeekUrl: squidBaseUrl + "/test/TotalDailyOutPutWeek/",
    // 根据渔船搜索日报总产量
    TotalDailyShip: squidBaseUrl + '/test/TotalDailyShip/',
    // 根据渔船搜索日报周产量
    TotalDailyShipWeek: squidBaseUrl + '/test/TotalDailyShipWeek/',
    // 日报公司
    DailyQueryUrl: squidBaseUrl + "/test/DailyQuery/",
    // 下拉框试验信息的显示
    FindTestSituationUrl: squidBaseUrl + "/test/FindTestSituation/",
    //获取80艘船
    BoatList: squidBaseUrl + '/fishery/ShipAll',
    //根据mmsi 搜索80艘船
    BoatSearch: squidBaseUrl + 'fishery/ShipSerch/',
    SleepFisherLayer: 'http://119.3.104.235:6080/arcgis/rest/services/xyq/MapServer/0?f=pjson',

    //==
};

const methods = {
    ///单mmsi查询
    singleMMSI: "ais_mmsi",
    //多个mmsi查询
    multiMMSI: "multi_ais_mmsi",
    ///范围查询
    extent: "ais_extent",
    //历史轨迹查询
    history: "ais_history",
};


//日志接口
const logApiConf = {
    saveLog: 'http://140.210.143.5:8080/ZsTunaAdmin/api/user/savelogs.html'
}

/**
 * 获取aisurl
 * @param {方法名称} mothod
 */
export function getAisUrl(mothod) {
    // return aisBaseUrl + mothod + '&param='
    return aisBaseUrl;
}

/**
 * 获取aisurl
 * @param {方法名称} mothod
 */
export function getFirstAisUrl(mothod) {
    return aisFirstBaseUrl + mothod + "&param=";
    // return aisBaseUrl
}

export function getFisherUrl() {
    return fisherUrlConf;
}
export function getSquidUrl() {
    return squidBaseUrlConf;
}

export function getTunaUrl() {
    return tunaUrlConf;
}
export function gethistoryNumUrl() {
    return historyNumUrl;
}

// 获取60艘中水渔船信息
export function getAllZsShipInfoUrl() {
    return "http://47.100.49.112:19080/dataapi/common/cmd?token=yy2018devtoken&method=" + methods.multiMMSI + "&"
}

export function postLogConf() {
    return logApiConf.saveLog;
}


// WEBPACK FOOTER //
// ./src/config/urlConfig.js